<template>
  <nav class="breadcrumb-nav" :class="`breadcrumb-nav--${variant}`" aria-label="Breadcrumb">
    <ol class="breadcrumb-list">
      <li
        v-for="(crumb, i) in items"
        :key="i"
        class="breadcrumb-item"
      >
        <router-link
          v-if="crumb.to"
          :to="crumb.to"
          class="breadcrumb-link"
        >{{ crumb.name }}</router-link>
        <span v-else class="breadcrumb-current" :aria-current="i === items.length - 1 ? 'page' : undefined">{{ crumb.name }}</span>
        <span v-if="i < items.length - 1" class="breadcrumb-sep" aria-hidden="true">
          <svg viewBox="0 0 16 16" width="10" height="10" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="6 4 10 8 6 12"/>
          </svg>
        </span>
      </li>
    </ol>
  </nav>
</template>

<script>
import { pageBreadcrumbMap } from '@/data/pageContent';

export default {
  name: 'BreadcrumbNav',
  props: {
    /** 路由路径，默认取当前路由 */
    path: { type: String, default: '' },
    /** 自定义当前页标题，可传入简化名称覆盖自动推断 */
    label: { type: String, default: '' },
    /** 显示风格：'hero' 深色背景 / 'light' 浅色背景 */
    variant: { type: String, default: 'hero' },
  },
  computed: {
    resolvedPath() {
      return this.path || (this.$route ? this.$route.path : '/');
    },
    currentLabel() {
      if (this.label) return this.label;
      const path = this.resolvedPath;
      if (path === '/download/' || path === '/download') return 'Download';
      if (path === '/' || path === '') return 'Home';
      // 从 pageBreadcrumbMap 查找父级名称，取其 name 作为当前页标题
      const item = Object.entries(pageBreadcrumbMap).find(([k]) => k === path);
      return item ? item[1].name : 'GB WhatsApp';
    },
    items() {
      const path = this.resolvedPath;
      const crumbs = [{ name: 'Home', to: '/' }];
      if (path !== '/' && path !== '') {
        const mapEntry = pageBreadcrumbMap[path];
        if (mapEntry) {
          // Hub 页面：直接显示 Hub 名称（当前页 = Hub）
          if (mapEntry.parentName) {
            crumbs.push({ name: mapEntry.parentName, to: null });
          }
          crumbs.push({ name: mapEntry.name, to: null });
        } else {
          // 未收录的页面：用 label 或 pageTitle
          crumbs.push({ name: this.currentLabel, to: null });
        }
      }
      return crumbs;
    },
  },
};
</script>

<style lang="scss" scoped>
.breadcrumb-nav {
  .breadcrumb-list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 2px;
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .breadcrumb-item {
    display: flex;
    align-items: center;
    gap: 2px;
  }

  .breadcrumb-sep {
    display: flex;
    align-items: center;
    opacity: 0.45;
  }

  /* ---- hero（深色背景 → 文字仍用深色，兼容下载页等浅色区） ---- */
  &--hero,
  &--light {
    .breadcrumb-link {
      font-size: 13px;
      color: #1f2937;
      text-decoration: none;
      transition: color 0.2s;
      &:hover { color: #4c78fd; }
    }
    .breadcrumb-sep { color: #9ca3af; }
    .breadcrumb-current {
      font-size: 13px;
      color: #111827;
      font-weight: 600;
    }
  }
}

@media (max-width: 768px) {
  .breadcrumb-nav {
    .breadcrumb-link,
    .breadcrumb-sep,
    .breadcrumb-current { font-size: 12px; }
  }
}
</style>
